import React from "react";
import profile from '../assent/d09289c694b09747fb10ee570d099d81.jpg';
import linkedin from '../assent//linkedin (1).png';
import github from '../assent/github.png';
import facebook from '../assent/facebook.png';
import behance from '../assent/behance.png';
import { ContactUs } from "./Contact";
import Services from "./Services";
import Skills from "./Skills";






function Hero(){

    return (
        <>
        
        <section className="home" id="home">
<div className="home-img">
    <img src={profile} />
</div>
<div className="home-content">
    <h1>Hi, It's <span>Khalid</span></h1>
    <h3 className="typing-text">I'm a <span></span></h3>
    <p>As a full-stack developer, I specialize in seamlessly integrating intuitive front-end design with robust back-end solutions, ensuring that your projects not only meet expectations but exceed them with a focus on user-centric experiences. I hold a Bachelor's degree in Information Systems and have over a year of experience as a full-stack engineer. I have also worked in the field of teaching, graphic design,, and UI/UX design. Currently, I am working as a front-end developer.</p>

<div className="socail-icon">
    <a href="https://www.linkedin.com/in/khalidali0"> <img className="img1" src={linkedin} /> </a>
    <a href="https://github.com/khalidali0000"><img className="img1" src={github} /></a>
    <a href="https://www.behance.net/khalidali45"><img className="img1" src={behance} /></a>
    <a href="https://www.facebook.com/khaleddesgin?mibextid=ZbWKwL"><img className="img1" src={facebook} /></a>
    {/* <!-- <a href="#"><i className="fa-solid fa-download"></i></a> --> */}
</div>
<a href="#" className="btn">Hire Me</a>
</div>
</section>
<Services />
<Skills />
<ContactUs />
        </>

        
    )
}
export default Hero